import { useAuth0 } from "@auth0/auth0-react"
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { allocateEventTaskAsync } from './currentEventTaskSlice'
import styles from './CurrentEventTask.module.css';
import { selectCurrentEventTaskId, setAllocatedUserEmail } from 
'./currentEventTaskSlice'
import { sanitizeEmail } from '../../utils/emailUtils'

export function ClaimEventTaskButton() {
     const dispatch = useAppDispatch()
     const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
     const currentEventTaskId = useAppSelector(selectCurrentEventTaskId)

     return (
            <button className={styles.claimTaskButton} onClick={async () => {

                 if (isAuthenticated && user?.email) {
                     if (currentEventTaskId > 0) {
                        
                        const accessToken = await getAccessTokenSilently({ authorizationParams : {
                        }})
                            
                        dispatch(allocateEventTaskAsync 
                            ({email:sanitizeEmail(user.email),token:accessToken}))
                         }
                 }
                 alert('Successfully Claimed This Task, Click Save To Confirm')
         }}> Claim Task</button>
     )
}

    